import { Component } from '@angular/core';
import {NotificationItem, PopupService} from "../../services/popup.service";
import {animate, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [
    trigger('slideRightLeft', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-out', style({ transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(100%)' }))
      ])
    ])
  ]
})
export class NotificationComponent {

  notifications$ = this.popupService.notifications$;

  constructor(public popupService: PopupService) {}

  close(id: number) {
    this.popupService.removeNotification(id);
  }

}
